import Vue from 'vue';
import VueI18n from 'vue-i18n';

// 引入您的语言文件
import en from './en.json';
import zh from './zh.json';
import ar from './ar.json';

// 告诉 Vue 使用 vue-i18n 插件
Vue.use(VueI18n);

// 从 localStorage 获取已保存的语言，如果没有则默认使用中文 'zh'
const normalizedLanguage = localStorage.getItem('language') === 'en' ? 'en' : 'zh';
localStorage.setItem('language', normalizedLanguage);
const savedLanguage = normalizedLanguage;

// 创建并导出一个新的 VueI18n 实例
const i18n = new VueI18n({
  locale: savedLanguage, // 设置初始语言
  fallbackLocale: 'zh',  // 设置回退语言
  messages: {
    en,
    zh,
    ar,
  },
});

export default i18n;